
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/can-i-trust-iyimakina",
      function () {
        return require("private-next-pages/about-us/can-i-trust-iyimakina.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/can-i-trust-iyimakina"])
      });
    }
  